module.exports = {"section_releases_title":"Julkaisut","section_shows_title":"Keikat"}